import dayjs from 'dayjs';

export default (value, format, defaultValue) => {
  const date = dayjs(value);

  if (date.isValid())
    return date.format(format);

  return defaultValue;
}
